import { render, staticRenderFns } from "./SilentRenewOIDC.vue?vue&type=template&id=63b0a96c&"
import script from "./SilentRenewOIDC.vue?vue&type=script&lang=ts&"
export * from "./SilentRenewOIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports